import { useFormContext } from 'react-hook-form';

import {
  useAccessToken,
  useSlug
} from 'reservations/account/providers/ConfigProvider';
import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { useModal } from 'reservations/base/providers/ModalProvider';
import { useBookingDetails } from 'reservations/booking/providers/BookingProvider';
import { useUpdateBookingMutation } from 'reservations/form/queries/useUpdateBookingMutation';
import { useUpdateBookingMutationV2 } from 'reservations/form/queries/useUpdateBookingMutationV2';

export const useSubmitReservationDetails = () => {
  const { handleIsLoading, handleHasLoaded } = useLoadingSpinner();
  const hasVisitId = useHasVisitId();
  const accessToken = useAccessToken();
  const slug = useSlug();
  const { bookingId } = useBookingDetails();
  const { handleSubmit } = useFormContext();
  const { close } = useModal();

  const updateBookingMutationV1 = useUpdateBookingMutation({
    slug,
    bookingId,
    apiKey: accessToken,
    handleSuccess: close,
    handleError: () => {}
  });
  const updateBookingMutationV2 = useUpdateBookingMutationV2();

  // istanbul ignore next
  const onSubmit = (data: Record<string, any>) => {
    handleIsLoading('Updating your reservation...');
    return hasVisitId
      ? updateBookingMutationV2.mutate(data)
      : updateBookingMutationV1.mutate(data);
  };

  return handleSubmit(onSubmit, handleHasLoaded);
};
